"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_intl_1 = require("react-intl");
var Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
var ArrowDropDown_1 = __importDefault(require("@mui/icons-material/ArrowDropDown"));
var Error_1 = __importDefault(require("@mui/icons-material/Error"));
var MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
var Button_1 = __importDefault(require("@mui/material/Button"));
var DropDownMenu_1 = __importDefault(require("../DropDownMenu"));
var actions_1 = require("../Auth/actions");
var MANAGE_ACCOUNT_ROLE = 'account:manage-account';
var RawUserPanel = function (_a) {
    var user = _a.user, auth = _a.auth, actions = _a.actions, userMenuActions = _a.userMenuActions, dispatchLogin = _a.login, dispatchLogout = _a.logout, dispatchAccountManagement = _a.accountManagement;
    if (auth.authenticationDisabled) {
        return null;
    }
    if (user.authenticated) {
        return (React.createElement(React.Fragment, null,
            actions,
            auth.error && (React.createElement(Tooltip_1.default, { title: React.createElement(react_intl_1.FormattedMessage, { id: "auth.error" }) },
                React.createElement(Error_1.default, { color: "error" }))),
            React.createElement(DropDownMenu_1.default, { color: "inherit", horizontalAlignment: "right", buttonContent: (React.createElement(React.Fragment, null,
                    user.fullName,
                    React.createElement(ArrowDropDown_1.default, null))) },
                userMenuActions,
                user.roles.includes(MANAGE_ACCOUNT_ROLE) && (React.createElement(MenuItem_1.default, { onClick: dispatchAccountManagement },
                    React.createElement(react_intl_1.FormattedMessage, { id: "auth.account-management" }))),
                React.createElement(MenuItem_1.default, { onClick: dispatchLogout },
                    React.createElement(react_intl_1.FormattedMessage, { id: "auth.logout" })))));
    }
    if (!auth.loading) {
        return (React.createElement(Button_1.default, { variant: "contained", color: "primary", onClick: dispatchLogin },
            React.createElement(react_intl_1.FormattedMessage, { id: "auth.login" })));
    }
    return null;
};
exports.default = (0, react_redux_1.connect)(function (_a) {
    var user = _a.user, auth = _a.auth;
    return ({
        user: user,
        auth: auth,
    });
}, { login: actions_1.login, logout: actions_1.logout, accountManagement: actions_1.accountManagement })(RawUserPanel);
